export const API_ACCES_TOKEN =
  "bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI1YzI5Nzk1OWNmMzM0N2MxYmVjZmU0ODQ3NzNmODliNCIsInN1YiI6IjY2NjdiNzE2OTE0Yjg4OTA3YWU5ZWZkYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.TVs4E2FC6H2_ax1pesVaqnQn8AkrY2GNMLdb63JSFmQ";

export const API_KEY = "5c297959cf3347c1becfe484773f89b4";

export const API_URL = "https://api.themoviedb.org/3/";
export const API_IMAGE = "https://image.tmdb.org/t/p/original";
export const USER_LANGUAGE = "en-US";
export const TV_OR_MOVIE = "movie";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 20;
